import React from 'react';
import {Command} from 'hooks';

type CommandContextType = {
	commands: Command[];
	addCommand: (command: Command) => () => void;
	removeCommand: (command: Command) => void;
};

/**
 * Stable dispatch-only context — never changes after mount.
 * Components that only need to register commands should use this
 * so they are NOT re-rendered when the commands list changes.
 */
export type CommandsDispatchContextType = {
	addCommand: (command: Command) => () => void;
	removeCommand: (command: Command) => void;
};

export const CommandsDispatchContext =
	React.createContext<CommandsDispatchContextType>(
		{} as CommandsDispatchContextType,
	);

/**
 * State context — re-renders consumers (e.g. AppCommandBar) when commands change.
 * Only use this in AppCommandBar. For registering commands use CommandsDispatchContext via useCommand.
 */
export const CommandsContext = React.createContext({} as CommandContextType);
